import React, { useState } from 'react';

export const ProjectCard = ({
  id,
  img,
  title,
  fund,
  description,
  category,
  percentage,
  daysLeft,
}) => {

  return ( 
      <div></div>
  );
};
